import _isEmpty from 'lodash/isEmpty'

import Layout from 'components/Layout'

import SectionBanner from './SectionBanner'
import SectionUSP from './SectionUSP'
import SectionStep from './SectionStep'
import SectionPromotion from './SectionPromotion'
import SectionSuccessStory from './SectionSuccessStory'
import SectionReview from './SectionReview'
import SectionFAQ from './SectionFAQ'
import SectionCTA from './SectionCTA'
import SectionInstallation from './SectionInstallation'

import Styled from './styled'

export default function CategoryService({ data }) {
  return (
    <Styled>
      <Layout>
        {!_isEmpty(data?.bannerSection) && (
          <div className="banner-container">
            <SectionBanner data={data.bannerSection} />
          </div>
        )}
        {!_isEmpty(data?.installationSection) && (
          <div className="installation-container">
            <div className="container">
              <SectionInstallation data={data.installationSection} />
            </div>
          </div>
        )}
        {!_isEmpty(data?.uspSection) && (
          <div className="usp-container">
            <div className="container">
              <SectionUSP data={data.uspSection} />
            </div>
          </div>
        )}
        {!_isEmpty(data?.stepSection) && (
          <div className="step-container">
            <div className="container">
              <SectionStep data={data.stepSection} />
            </div>
          </div>
        )}
        {!_isEmpty(data?.promotionSection?.promotions) && (
          <div className="promotion-container">
            <div className="container">
              <SectionPromotion data={data.promotionSection} />
            </div>
          </div>
        )}
        {!_isEmpty(data?.successStorySection?.contents) && (
          <div className="success-container">
            <div className="container">
              <SectionSuccessStory data={data.successStorySection} />
            </div>
          </div>
        )}
        {!_isEmpty(data?.reviewSection?.reviewContent) && (
          <div className="review-container">
            <div className="bg-1" />
            <div className="bg-2" />

            <div className="container">
              <SectionReview data={data.reviewSection} />
            </div>
          </div>
        )}

        {!_isEmpty(data?.faqSection) && (
          <div className="faq-container">
            <div className="container">
              <SectionFAQ data={data.faqSection} />
            </div>
          </div>
        )}
        {!_isEmpty(data?.ctaSection) && (
          <div className="cta-container">
            <div className="container">
              <SectionCTA data={data.ctaSection} />
            </div>
          </div>
        )}
      </Layout>
    </Styled>
  )
}
